import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logoImage from "../assets/images/MM-Final-Logo.webp";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const nav = (path) => {
    navigate(path);
    setMenuOpen(false);
    window.scrollTo(0, 0);
  };

  const links = [
    { label: "About", path: "/about" },
    { label: "Millets", path: "/millets" },
    { label: "Menu", path: "/menu" },
    { label: "Blog", path: "/blog/healthy-momos-hyderabad" },
    { label: "Contact", path: "/contact" },
  ];

  return (
    <>
      <nav className={scrolled ? "scrolled" : ""}>
        <div className="nav-inner">
          
          {/* Logo */}
          <div className="logo-wrap" onClick={() => nav("/")}>
            <img src={logoImage} alt="Millet Momos Logo" className="logo-img" loading="lazy" />
            <span className="logo-text">MILLETMOMOS</span>
          </div>

          {/* Desktop Menu */}
          <ul className="nav-links">
            {links.map(l => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  className={location.pathname === l.path ? "active" : ""}
                  onClick={() => setMenuOpen(false)}
                >
                  {l.label}
                </Link>
              </li>
            ))}

            <li>
              <Link
                to="/contact"
                className="nav-cta"
                onClick={() => setMenuOpen(false)}
              >
                Order Now
              </Link>
            </li>
          </ul>

          {/* Hamburger */}
          <button
            className={`hamburger${menuOpen ? " open" : ""}`}
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* Overlay */}
      <div className={`mob-overlay${menuOpen ? " open" : ""}`} onClick={() => setMenuOpen(false)} />

      {/* Mobile Menu */}
      <div className={`mob-menu${menuOpen ? " open" : ""}`}>
        <ul>
          {links.map(l => (
            <li key={l.path}>
              <Link to={l.path} onClick={() => nav(l.path)}>
                {l.label}
              </Link>
            </li>
          ))}

          <li>
            <Link
              to="/contact"
              className="nav-cta"
              style={{
                background: "var(--red)",
                color: "#fff",
                padding: ".65rem 1.4rem",
                borderRadius: "8px",
                display: "block",
                textAlign: "center",
                marginTop: "1rem"
              }}
              onClick={() => nav("/contact")}
            >
              Order Now
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
}